import React from "react";
import styled from "styled-components";

export default styled.div`

    color: #273644;
    font-size: 16px;
    line-height: 20px;
    
        display: ${(props) => (props.hidden ? "none" : "block")};
`;